/* Buy Button After Price */
document.addEventListener('DOMContentLoaded', function() {
  function addBtn() {
    document.querySelectorAll('.collection .card__content').forEach(function(card) {
      if(card.querySelector('.bb-buy-btn')) return;
      var price = card.querySelector('.price');
      var link = card.closest('.grid__item, .card-wrapper')?.querySelector('a[href*="/products/"]');
      if(!price || !link) return;
      var btn = document.createElement('a');
      btn.href = link.href;
      btn.className = 'bb-buy-btn';
      btn.textContent = 'Commander';
      btn.style.cssText = 'display:block;width:100%;padding:12px;background:#111;color:#fff;text-align:center;text-decoration:none;font-size:11px;font-weight:700;text-transform:uppercase;border-radius:6px;margin-top:10px;order:4';
      btn.onmouseenter = function(){this.style.background='#FFD700';this.style.color='#111';};
      btn.onmouseleave = function(){this.style.background='#111';this.style.color='#fff';};
      price.after(btn);
    });
  }
  addBtn();
  setTimeout(addBtn, 1000);
  setTimeout(addBtn, 2000);
});